import { useEffect } from "react";
import { FONTS, loadFonts } from "../../lib/fonts";
import { lazyImgs } from "../../lib/html";

export function RichHtml({ html, className = "", testid }) {
  useEffect(() => {
    const used = FONTS.filter((f) => html?.includes(f));
    if (used.length) loadFonts(used, `rich-${used.join("-")}`);
  }, [html]);
  if (!html || !html.replace(/<[^>]+>/g, "").trim()) return null;
  return <div className={`prose-site ${className}`} data-testid={testid} dangerouslySetInnerHTML={{ __html: lazyImgs(html) }} />;
}
